import {
	IconSize50,
	IconSize75,
	IconSize100,
	IconSize150,
	IconSize200,
	IconSize300,
	IconSize400,
	IconSize500,
	IconSize625,
	IconSize750,
} from "@mv/design-tokens/variables";
import { type SVGProps } from "react";
export interface Props
	extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
	size?:
		| "50"
		| "75"
		| "100"
		| "150"
		| "200"
		| "300"
		| "400"
		| "500"
		| "625"
		| "750";
}
const sizeMap = {
	50: IconSize50,
	75: IconSize75,
	100: IconSize100,
	150: IconSize150,
	200: IconSize200,
	300: IconSize300,
	400: IconSize400,
	500: IconSize500,
	625: IconSize625,
	750: IconSize750,
};
export default function VikingHelmetBlack({ size = "100", ...props }: Props) {
	return (
		<svg
			xmlns={"http://www.w3.org/2000/svg"}
			{...props}
			viewBox="0 0 24 24"
			width={sizeMap[size]}
			height={sizeMap[size]}
		>
			<defs>
				<path id="a" d="M0 0h5.727v8.88H0z" />
				<path id="c" d="M0 0h5.728v8.88H0z" />
				<path id="e" d="M0 0h14.309v10.94H0z" />
			</defs>
			<g fill="none" fillRule="evenodd">
				<path
					fill="#E42822"
					fillRule="nonzero"
					d="M7.69 16.132a.349.349 0 1 1-.697 0 .349.349 0 0 1 .697 0"
				/>
				<path
					fill="#E42822"
					fillRule="nonzero"
					d="M7.341 15.962c-.11 0-.201.1-.201.223 0 .124.09.224.202.224.11 0 .201-.1.201-.224 0-.123-.09-.223-.202-.223m0 .773c-.274 0-.495-.246-.496-.55 0-.303.222-.55.496-.55s.496.247.497.55c0 .304-.223.55-.497.55m9.61-.55a.4.4 0 0 1-.174.335.32.32 0 0 1-.349 0 .4.4 0 0 1-.174-.335c0-.213.156-.386.349-.386s.348.173.348.386"
				/>
				<path
					fill="#E42822"
					fillRule="nonzero"
					d="M16.603 15.93a.2.2 0 0 0-.202.202.202.202 0 0 0 .403 0 .2.2 0 0 0-.201-.202m0 .698a.497.497 0 1 1 0-.994.497.497 0 0 1 0 .994m-4.185.378a.349.349 0 1 1-.697 0 .35.35 0 0 1 .697 0"
				/>
				<path
					fill="#E42822"
					fillRule="nonzero"
					d="M12.123 16.837a.224.224 0 1 0 .001.447.224.224 0 0 0-.001-.447m0 .773a.55.55 0 1 1 .001-1.1.55.55 0 0 1-.001 1.1"
				/>
				<g transform="translate(1 5)">
					<mask id="b" fill="#fff">
						<use xlinkHref="#a" />
					</mask>
					<path
						fill="#000"
						fillRule="nonzero"
						d="M4.159 8.88a.4.4 0 0 1-.114-.018C2.355 8.328.289 6.935.033 4.772-.245 2.43 1.276.804 2.057.383 2.96-.103 3.603-.129 3.865.308c.215.358.09.792-.305 1.054-.136.105-1.028 1.051-.75 1.974.332 1.098 2.041 1.673 2.614 1.788a.377.377 0 0 1-.147.74c-.027-.005-2.657-.548-3.189-2.31-.404-1.339.686-2.517 1-2.779-.152.035-.38.114-.673.272-.518.28-1.867 1.66-1.633 3.636.214 1.807 2.014 2.993 3.49 3.46a.377.377 0 0 1-.113.737"
						mask="url(#b)"
					/>
				</g>
				<g transform="translate(17.272 5)">
					<mask id="d" fill="#fff">
						<use xlinkHref="#c" />
					</mask>
					<path
						fill="#000"
						fillRule="nonzero"
						d="M1.569 8.88a.377.377 0 0 1-.114-.737c1.476-.467 3.277-1.653 3.49-3.46.234-1.976-1.114-3.357-1.632-3.636a2.8 2.8 0 0 0-.674-.272c.314.262 1.405 1.44 1 2.78C3.107 5.318.477 5.859.45 5.865a.377.377 0 0 1-.147-.741c.573-.115 2.282-.69 2.614-1.788.279-.923-.614-1.869-.758-1.98-.386-.257-.511-.69-.296-1.048.262-.437.904-.41 1.807.075.78.421 2.302 2.047 2.025 4.39-.257 2.162-2.322 3.555-4.012 4.09a.4.4 0 0 1-.114.017"
						mask="url(#d)"
					/>
				</g>
				<g transform="translate(4.886 7.454)">
					<mask id="f" fill="#fff">
						<use xlinkHref="#e" />
					</mask>
					<path
						fill="#000"
						fillRule="nonzero"
						d="M.754 8.332c.319.363 1.89 1.853 6.195 1.853 4.498 0 6.237-1.488 6.605-1.865V6.469c0-1.526-1.582-5.714-6.675-5.714C1.018.755.754 6.41.754 6.469zM6.95 10.94C1.615 10.94.123 8.763.062 8.67L0 8.577V6.47C0 4.79 1.264 0 6.879 0c5.669 0 7.43 4.742 7.43 6.469v2.123l-.078.101c-.07.092-1.789 2.247-7.282 2.247"
						mask="url(#f)"
					/>
				</g>
				<path
					fill="#000"
					fillRule="nonzero"
					d="M11.835 16.13c-5.365 0-6.828-2.153-6.888-2.245a.378.378 0 0 1 .631-.414c.025.036 1.376 1.905 6.257 1.905 5.077 0 6.671-1.911 6.687-1.93a.378.378 0 0 1 .594.465c-.07.09-1.788 2.22-7.28 2.22"
				/>
				<path
					fill="#000"
					fillRule="nonzero"
					d="M11.805 14.33a.377.377 0 0 1-.377-.378V6.936a.377.377 0 0 1 .754 0v7.016a.377.377 0 0 1-.377.377"
				/>
			</g>
		</svg>
	);
}
